import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ArrowDownCircleSVG = function ArrowDownCircleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm7.69 15.69l-6.89 7a1.13 1.13 0 01-.8.31 1.09 1.09 0 01-.8-.31l-6.89-7a1.07 1.07 0 010-1.5 1 1 0 011.48 0L15 21.5V8a1 1 0 112 0v13.5l5.22-5.31a1 1 0 011.48 0 1.07 1.07 0 01-.01 1.5z"
  }));
};
ArrowDownCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ArrowDownCircleSVG);